import axios from 'axios'

/*
  This communication object is responsible for sending requests as per the configurations provided by the service-gala and service-nqc classes.
*/

const instance = axios.create();
var retrytimes = 0;

// Take any request and add our token to it if authorization is needed
instance.interceptors.request.use(
  async function (config) {
    if (config.headers.Authorization)
    {
      var token = sessionStorage.getItem("token");
      if(!token || config.baseURL.includes("NQWebServices")) // sessionStorage.token === null || sessionStorage.token === undefined <-- this would do if NQC didn't need a new token for every office
      {
        await RefreshToken().then(res => { return true;}).catch(error => console.log(error));
      }
      config.headers.Authorization = "Bearer " + sessionStorage.token;
    }

    return config;
  }, function (error) {
    console.log(error)
  }
)
// If we get a 403-response this means we need to refresh our bearer token
instance.interceptors.response.use(
  function (res) {
    retrytimes = 0;
    return res;
  },
  async function (error) {
    console.log(error)
    const config = error.config;
    if (error.response.status === 401 || error.response.status === 403 || error.code === 'ECONNABORTED')
    {
      if (retrytimes < 3)
      {
        sessionStorage.token = null;
        config._retry = false;
        retrytimes++;
        await RefreshToken().then(res => { return true;}).catch(error => console.log(error));
        config.headers.Authorization = 'Bearer ' +  sessionStorage.token;
        return instance(config)
      }
      else
        retrytimes = 0;
    }
    else if (error.response.statusText.includes('no ticket'))
    {
      if (retrytimes < 3)
      {
        sessionStorage.token = null;
        config._retry = false;
        retrytimes++;
        await RefreshToken().then(res => { return true;}).catch(error => console.log(error));
        config.headers.Authorization = 'Bearer ' +  sessionStorage.token;
        return instance(config)
      }
      else
      {
        retrytimes = 0;
        localStorage.removeItem("ticket");
      }
    }
    
    return Promise.reject(error)
  }
)

// Refreshes the bearer token
// To be called automatically when needed
// Due to how I have constructed it, the token config will have to be saved in the session state by the active service file
async function RefreshToken() {

  const config = JSON.parse(sessionStorage.tokenconfig);
  return await axios ( config ).then(res => { sessionStorage.token = res.data.access_token; return true;}).catch(error => console.debug(error));
}

// Returns data based on configuration input
export async function CallWithConfig(config, timeout) {
  config.timeout = timeout || 5000;
  //config.cancelToken = axios.CancelToken.source();
  const result = await instance( config ).then(res => { return res.data;}).catch(error => console.log(error));
  return result;
}